import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Badge,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { useHistory } from "react-router-dom";
import { LOANPLANTYPEID } from "../../config/cacheKey";
import { GetAllLoanTemplatesResponse } from "../../models/loanTemplate.model";
import SpecificationsPlan from "./specificationsPlan";
import LinearGradientBox from "../../components/box/linearGradientBox";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    top: 8,
    right: 8,
    backgroundColor: "#f44336",
    color: "white",
  },
}));

export default function LoanPlan(item: GetAllLoanTemplatesResponse) {
  const isTablet = useMediaQuery("(max-width: 900px)");
  const history = useHistory();
  const handleDetailes = (id: number) => {
    localStorage.setItem(LOANPLANTYPEID, String(id));
    history.push("/plans/loanPlanDetail");
  };
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "4px !important",
        backgroundColor: "#F6F8F9",
        mb: 2,
        mx: 2,
        boxShadow:
          "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
      }}
    >
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{
            flexDirection: {
              xs: "column",
              md: "row",
            },
          }}
        >
          <Grid
            item
            xs={12}
            md={7}
            container
            sx={{
              flexDirection: {
                xs: "column",
                md: "row",
              },
              justifyContent: {
                xs: "center",
                md: "flex-start",
              },
              alignItems: "center",
              textAlign: {
                xs: "center",
                md: "right",
              },
            }}
          >
            <Grid item>
              {/* <StyledBadge badgeContent="غیرفعال" color="error"> */}
              <LinearGradientBox color={item.walletTypeColorHexCode} />
              {/* <img
                src={`data:image/png;base64,${item.walletTypeLogo}`}
                alt="plan"
                style={{ objectFit: "contain", borderRadius: "4px" }}
              /> */}
              {/* </StyledBadge> */}
            </Grid>
            <Grid
              item
              sm={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: { xs: "center", md: "flex-start" },
              }}
            >
              <Typography variant="h6" mt={1}>
                {item.loanTemplateTitle}{" "}
                {item.isActive == true ? (
                  <b style={{ color: "#28A745" }}>(فعال)</b>
                ) : (
                  <b style={{ color: "#E6123D" }}>(غیرفعال)</b>
                )}
              </Typography>
              {item.walletTypeTitle && (
                <Typography
                  mt={1}
                  sx={{
                    backgroundColor: "#1D4A87",
                    paddingX: 1,
                    paddingY: 0.5,
                    borderRadius: "8px",
                    width: "fit-content",
                    color: "white",
                  }}
                >
                  {item.walletTypeTitle}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={5}
            onClick={() => handleDetailes(item.loanTemplateId)}
            sx={{ cursor: "pointer", textAlign: { xs: "center", md: "left" } }}
          >
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ color: "#1D4A87", paddingLeft: "10px" }}
            >
              <VisibilityOutlinedIcon fontSize="small" />
              &nbsp;مشاهده جزییات طرح تسهیلات
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <SpecificationsPlan item={item} />
      </CardContent>
    </Card>
  );
}
